import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { tVE, tVEwithDetailedResources, tVEType } from './glowadminservices/glowadmin.typings';
import { GlowAdminService } from './glowadminservices/glowadmin.service';
import { ApplicationSelectorService } from './app-selector.service';
import { tVeTypeDictionary } from './ui.typings';

@Injectable()
export class VirtualEntityService {

    serviceId: string = 'VirtualEntityService'
    applicationId: string

    veTypeListDictionary: tVeTypeDictionary;

    private VeListAnnouncer = new Subject<tVE[]>();
    private VirtualEntityDetailedResourcesAnnouncer = new Subject<tVEwithDetailedResources>();
    private VeTypeListAnnouncer = new Subject<tVEType[]>();

    veList$ = this.VeListAnnouncer.asObservable()
    veDetailedResources$ = this.VirtualEntityDetailedResourcesAnnouncer.asObservable()
    veTypeList$ = this.VeTypeListAnnouncer.asObservable()

    constructor(
        private appService: ApplicationSelectorService,
        private glowAdminService: GlowAdminService) {

        var application = JSON.parse(localStorage.getItem('application'));

        if (application) {
            this.applicationId = application.applicationId;
        }
        this.appService.getSelectedApplication.subscribe(application => {
            var application = JSON.parse(localStorage.getItem('application'));
            this.applicationId = application.applicationId;
            console.log(this.serviceId + " Application has been announced, setting applicationId to " + this.applicationId);
        });
    };

    findVirtualEntities(userId = null) {

        this.glowAdminService
            .getVEs(this.applicationId, userId)
            .subscribe(ves => {
                var virtualEntities = ves;
                this.announceVirtualEntityList(virtualEntities);
            }, error => {
                console.warn("An error occurred when querying for the VEs");
                console.warn(error)
                this.announceVirtualEntityList([]);
            });
    };

    findVeTypeList() {
        this.glowAdminService
            .getVETypes(this.applicationId)
            .subscribe(veTypeList => {
                this.setVirtualEntityTypeDictionary(veTypeList)
                this.announceVeTypeList(veTypeList);
            }, error => {
                console.warn("An error occurred when querying for the VE types");
                console.warn(error)
            });
    }

    setVirtualEntityTypeDictionary(veTypeList: tVEType[]) {
        var veTypeListDictionary = {};
        for (var i=0; i<veTypeList.length; i++){
            veTypeListDictionary[veTypeList[i].veTypeId] = veTypeList[i];
        }

        this.veTypeListDictionary = veTypeListDictionary
        console.log("veTypeListDictionary")
        console.log(this.veTypeListDictionary)
    }

    getVirtualEntityTypeDictionary(): tVeTypeDictionary {
        if (this.veTypeListDictionary){
            return this.veTypeListDictionary
        } else {
            this.findVeTypeList();
            return {}
        }
    }

    findVirtualEntityWithDetailedResources(veId: string, userId = null) {

        this.glowAdminService
            .getVeWithDetailedResources(this.applicationId, veId, userId)
            .subscribe(veDetailedResources => {
                this.announceVirtualEntityWithResources(veDetailedResources);
            }, error => {
                console.warn("An error occurred when querying for the VE " + veId);
                console.warn(error)
            });
    };

    announceVirtualEntityWithResources(virtualEntityFullResources: tVEwithDetailedResources) {
        console.log("Announce virtualEntityFullResources" + virtualEntityFullResources.veId);
        this.VirtualEntityDetailedResourcesAnnouncer.next(virtualEntityFullResources);
    }

    announceVirtualEntityList(veList: tVE[]) {
        console.log("Announce VE has not been set or found");
        // some process needs to start potential that triggers potential rechecking
        this.VeListAnnouncer.next(veList);
    };

    announceVeTypeList(veTypeList: tVEType[]) {
        console.log("Announce VE Type has not been set or found");
        // some process needs to start potential that triggers potential rechecking
        this.VeTypeListAnnouncer.next(veTypeList);
    };

    // updateVirtualEntity(veId: string, updateBody: any) {
    //     var updateBodyVe = {};

    //     for (var key in updateBody) {
    //         if (updateBody.hasOwnProperty(key) && updateBody[key]) {
    //             updateBodyVe[key] = updateBody[key]
    //         }
    //     }

    //     this.glowAdminService.updateVirtualEntity(veId, updateBodyVe)
    //         .subscribe((updatedVirtualEntity) => {


    //         }, error => {
    //             console.warn(error)
    //         })
    // }
};